module.exports = __webpack_public_path__ + "static/media/upload-icon.7c4eb3b9.svg";